import React from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import { EVENT_FAQ_CONST } from './data/constants';
import { eventFaqDefinition } from './data/eventFaqDefinition';
import { kitchensSelected } from './data/utils';
import { injectIntl } from 'react-intl';
import FoodBeverageContent from './content/FoodBeverageContent';
import FoodBeverageExpanded from './content/FoodBeverageExpanded';

const FoodBeverageRules = ({ faqData = {}, intl, expanded = false }) => {
  const eventFaqSelection = Object.keys(faqData);
  const { FOOD_BEVERAGE_RULES, FOOD_PREP_RULES } = EVENT_FAQ_CONST;
  const selectedKitchenSetups = kitchensSelected(faqData);
  // food beverage rules
  const foodBevProps = eventFaqDefinition.food_and_beverage[FOOD_BEVERAGE_RULES][faqData[FOOD_BEVERAGE_RULES]];
  const foodAndBeverage = foodBevProps ? intl.formatMessage(foodBevProps) : faqData[FOOD_BEVERAGE_RULES];
  // food prep rules
  const foodPrepProps = eventFaqDefinition.food_and_beverage[FOOD_PREP_RULES][faqData[FOOD_PREP_RULES]];
  const foodPrepRules = foodPrepProps ? intl.formatMessage(foodPrepProps) : faqData[FOOD_PREP_RULES];
  // kitchen amenities
  const kitchenAmenitiesOptions = get(eventFaqDefinition, 'food_and_beverage.kitchen_amenities_provided', {});
  const kitchenAmenityChoices = Object.keys(get(eventFaqDefinition, 'food_and_beverage.kitchen_amenities_provided', {}));
  const kitchenAmenities = eventFaqSelection.reduce((acc, key) => -1 !== kitchenAmenityChoices.indexOf(key) ? acc.concat([key]) : acc, []);
  if (expanded) {
    return (
      <>
        <FoodBeverageExpanded
          foodAndBeverage={foodAndBeverage}
          foodPrepRules={foodPrepRules}
        />
      </>
    );
  }
  return (
    <>
      <FoodBeverageContent
        faqData={faqData}
        foodAndBeverage={foodAndBeverage}
        foodPrepRules={foodPrepRules}
        selectedKitchenSetups={selectedKitchenSetups}
        kitchenAmenities={kitchenAmenities}
        kitchenAmenitiesOptions={kitchenAmenitiesOptions}
      />
    </>
  );
};

FoodBeverageRules.propTypes = {
  faqData: PropTypes.object,
  intl: PropTypes.object,
  expanded: PropTypes.bool
};

export default injectIntl(FoodBeverageRules);
